module.exports = __webpack_public_path__ + "images/cebsb_logo.1790041056745.png";